import Link from "next/link";
import styles from "../../styles/NavigationBar.module.scss";
import { isLoggedInState, usernameState } from "../atoms/auth";
import usePersistState from "../hooks/usePersistState";

export default function NavigationBar() {
  const [isLoggedIn, setIsLoggedIn] = usePersistState(
    isLoggedInState,
    "jwtToken",
    (data) => Boolean(data)
  );

  const [username, setUsername] = usePersistState(usernameState, "username");

  function logOut() {
    sessionStorage.clear();
    setIsLoggedIn(false);
    setUsername("");
  }

  return (
    <div className={styles.navbar}>
      <Link href="/">
        <h1>HarTy</h1>
      </Link>
      <div className={styles.menu}>
        <Link href="#">
          <a>ABOUT US</a>
        </Link>
        <Link href="/activity">
          <a>ALL ACTIVITIES</a>
        </Link>
        {!isLoggedIn && (
          <Link href="/login">
            <a>LOG IN</a>
          </Link>
        )}
        {isLoggedIn && (
          <Link href="/">
            <a onClick={logOut}>LOG OUT</a>
          </Link>
        )}
        {!isLoggedIn && (
          <Link href="/register">
            <a>REGISTER</a>
          </Link>
        )}
        {isLoggedIn && (
          <Link href="/account">
            <a>{username}</a>
          </Link>
        )}
      </div>
    </div>
  );
}
